import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  Link,
} from 'react-router-dom';
import { actions } from 'react-redux-form';
import get from 'lodash/get';
// import has from 'lodash/has';
import uuid from 'uuid/v4';

import {
  signUp,
  navigate,
  fetchAccounts,
  fetchUser,
  fetchAccountData,
  setAccreditation,
} from '../../actions';
import { isAccredited } from '../../helpers';
import {
  addNotification,
} from '../../actions/notifications';
import NotificationList from '../Notifications';
import SetUpCredentials from './SetUpCredentialsRrf';
import PersonalInfoRrf from './PersonalInfoRrf';
import InvestmentInfoRrf from './InvestmentInfoRrf';
// import BankInfo from './BankInfo';
import Signature from './Signature';
import logo from '../../assets/images/logo.svg';
import loadGif from '../../assets/images/loading.gif';

import {
  persInfoPath,
  credentialsPath,
  investmentInfoPath,
  baseSignupPath,
} from '../Forms/Schemas/baseRrf';

import { logEvent } from '../../helpers/analytics';

import './styles.css';

// const debug = require('debug')('cambria:SignUp');


const DEFAULT_POST_SIGN_UP_URL = '/offers';
const USER_ALREADY_HAS_ACCOUNT_URL = '/already-have-an-account';


export const routes = [
  { step: 'Account', path: 'set-up-credentials', Comp: SetUpCredentials },
  { step: 'Personal', path: 'personal-info', Comp: PersonalInfoRrf },
  { step: 'Investment', path: 'investment-info', Comp: InvestmentInfoRrf },
  // { step: 'Banking', path: 'bank-setup', Comp: BankInfo },
  { step: 'Signature', path: 'signature', Comp: Signature },
];

const steps = [
  'Account',
  'Personal',
  'Investment',
  // 'Banking',
];

const Progress = ({
  url,
  currStep,
  personalChanged,
  personalValid,
  investChanged,
  investValid,
  // bankChanged,
}) => (
  <div styleName="progress">
    {steps.map((step) => {
      const styleName = currStep === step ? 'progress-current-step' : 'progress-step';
      let link = false;
      const route = routes.find(rte => (rte.step === step));
      switch (step) {
        case 'Personal':
          link = personalChanged && personalValid;
          break;
        case 'Investment':
          link = investChanged && personalValid && investValid;
          break;
        // case 'Banking':
        //   link = bankChanged && personalValid && investValid;
        //   break;
        // no default
      }
      const comp = link ? (
        <Link
          key={step}
          to={`${url}/${route.path}`}
          styleName={styleName}
        >
          {step}
        </Link>
      )
      : (
        <div
          key={step}
          styleName={styleName}
        >
          {step}
        </div>);
    return comp;
  })}
  </div>
);


class SignUp extends Component {
  constructor(props) {
    super(props);
    const route = this.getRoute();
    this.state = {
      step: route && route.step,
      loading: false,
      sessionid: uuid(),
    };
  }

  componentWillReceiveProps(nextProps) {
    const { user } = nextProps;
    if (user && user.signUpCompleted) {
      this.props.navigate(USER_ALREADY_HAS_ACCOUNT_URL);
    } else {
      const route = this.getRoute(nextProps);
      this.setState({ step: route && route.step });
    }
  }

  onNext = async () => {
    const { match } = this.props;
    const nextRoute = this.getNextRoute();
    if (nextRoute) {
      logEvent('signup', nextRoute.step, this.state.sessionid);
      this.props.navigate(`${match.url}/${nextRoute.path}`);
    } else {
      window.scrollTo(0, 0);
      // no nextRoute means at then of sign up routes so sign up
      // then redirect to next
      if (this.state.loading) {
        return;
      }
      this.setState({ loading: true });
      try {
        const { annualIncome, totalNetWorth } = this.props.rrSignupForms.investmentInfo.finances;
        isAccredited(annualIncome, totalNetWorth, flag => this.props.setAccreditation(flag));
        await this.props.signUp();
        await this.props.fetchAccounts();
        await this.props.fetchUser();
        await this.props.resetPersInfo();
        await this.props.resetCredInfo();
        await this.props.resetInvestInfo();
        await this.props.resetSignupInfo();
        await this.props.fetchAccountData(this.props.accountNumber);
        logEvent('signup', 'Success', this.state.sessionid);
        this.props.navigate(DEFAULT_POST_SIGN_UP_URL);
        return;
      } catch (err) {
        const { error } = await err.res.json();
        switch (err.res.status) {
          case 400:
            if (error && error.validationErrors
                && Object.keys(error.validationErrors).length > 0) {
              Object.keys(error.validationErrors).forEach((key) => {
                if (/member\.unique\.ssn\.rule/mg.test(error.validationErrors[key].msg)) {
                  this.props.addNotification('Unable to create an account with the provided social security number.');
                } else {
                  this.props.addNotification(`Invalid ${error.validationErrors[key].param}: ${error.validationErrors[key].msg}`);
                }
              });
            } else {
              this.props.addNotification('Sign-up failed due to invalid data.  Please review your changes and try again.');
            }
            break;
          default:
            this.props.addNotification(`Sign-up failed ${err.message}. Please try again later.`);
            break;
        }
      }
      this.setState({ loading: false });
    }
  }

  getRouteIndex = (props) => {
    const { match, location } = props || this.props;
    const curPath = location.pathname.replace(new RegExp(`^${match.url}/`), '');
    return routes.findIndex(route => route.path === curPath);
  }

  getRoute = props => routes[this.getRouteIndex(props)];
  getNextRoute = props => routes[this.getRouteIndex(props) + 1];

  render() {
    const { match, authTokenUser } = this.props;
    if (!this.state.loading && authTokenUser && authTokenUser.signUpCompleted) {
      return <Redirect to="/portfolio" push={false} />;
    }
    return (
      <div styleName="wrapper">
        <Link to="/">
          <img
            src={logo}
            alt="My IPO"
            styleName="logo"
          />
        </Link>
        {this.state.loading ? (
          <div styleName="loading">
            <div styleName="loadingText">Creating account <div styleName="loadingTextEllipsis" /></div>
            <img styleName="loadingGif" src={loadGif} alt="Loading" />
          </div>
        ) : (
          <div>
            <NotificationList />
            <div styleName="message">
              You are steps away from being able to invest in some of the most exciting IPOs
              and other offerings!
            </div>
            <Progress
              url={match.url}
              currStep={this.state.step}
              personalChanged={!this.props.isPersInfoPristine}
              personalValid={this.props.isPersInfoValid}
              investChanged={!this.props.isInvestInfoPristine}
              investValid={this.props.isInvestInfoValid}
              // bankChanged={!this.props.isBankingPristine}
            />
            <div styleName="body">
              <Switch>
                {routes.map(({ path, Comp }) => (
                  <Route
                    key={path}
                    exact
                    path={`${match.url}/${path}`}
                    render={props => <Comp {...props} onNext={this.onNext} />}
                  />
                ))}
                <Redirect to={`${match.url}/${routes[0].path}`} />
              </Switch>
            </div>
          </div>
        )}
      </div>
    );
  }
}


const mapStateToProps = ({
  authTokenUser,
  user,
  signUpInfo,
  rrSignupForms,
  currentAccount,
}) => ({
  authTokenUser,
  user,
  signUpInfo,
  rrSignupForms,
  accountNumber: currentAccount,
  isPersInfoPristine: get(rrSignupForms, 'forms.personalInfo.$form.pristine', true),
  isPersInfoValid: get(rrSignupForms, 'forms.personalInfo.$form.valid', false),
  isInvestInfoPristine: get(rrSignupForms, 'forms.investmentInfo.$form.pristine', true),
  isInvestInfoValid: get(rrSignupForms, 'forms.investmentInfo.$form.valid', false),
  // isBankingPristine: !has(signUpInfo, 'plaidInfo'),
});


const mapDispatchToProps = dispatch => ({
  setAccreditation: (...args) => (dispatch(setAccreditation(...args))),
  signUp: () => (dispatch(signUp())),
  navigate: (...args) => (dispatch(navigate(...args))),
  fetchAccounts: (...args) => (dispatch(fetchAccounts(...args))),
  fetchUser: () => (dispatch(fetchUser())),
  resetPersInfo: () => (dispatch(actions.reset(persInfoPath))),
  resetCredInfo: () => (dispatch(actions.reset(credentialsPath))),
  resetInvestInfo: () => (dispatch(actions.reset(investmentInfoPath))),
  resetSignupInfo: () => (dispatch(actions.reset(baseSignupPath))),
  addNotification: (...args) => (dispatch(addNotification(...args))),
  fetchAccountData: (...args) => (dispatch(fetchAccountData(...args))),
});


export default connect(mapStateToProps, mapDispatchToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/components/SignUp/index.js